import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Image from 'mui-image';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';

const PageContainer = (props) => {
    const theme = useTheme();
    return(
    <Container sx={{ backgroundColor:theme.palette.background.default, boxShadow:`0px 0px 70px 100px ${theme.palette.background.default}`, pt: 10}}r>
        { props.header_image && <Image src={ props.header_image } height="300px" width="100%" fit="cover" sx={{ objectPosition:"50% " + (props.header_image_position || 95) + "%", mt: 0.5 }} />}
        <Box sx={{ display:"flex", width:'100%', maxWidth:'900px', justifyItems:'center', position: 'absolute', top: "80px", left: '50%', transform: 'translateX(-50%)'}}>
            { props.header && <Typography sx={{typography:{ xs:'h4', sm:'h3' }, mx:'auto', textAlign:'center', backgroundColor:theme.palette.background.default, padding:"20px", borderBottomLeftRadius:5, borderBottomRightRadius:5}}>{ props.header }</Typography> }
        </Box>
        <Box sx={{ mt:3}}>
            { props.children }
        </Box>
    </Container>
    );
};

export default PageContainer;